export const xLargeMultiplier = 1.15;
export const phoneMultiplierSmall = 0.8;
